// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimPaymentBatchModel {
    static getAttributeTypeMap() {
        return ClaimPaymentBatchModel.attributeTypeMap;
    }
}
ClaimPaymentBatchModel.discriminator = undefined;
ClaimPaymentBatchModel.additionalProperties = false;
ClaimPaymentBatchModel.attributeTypeMap = [
    {
        "name": "paymentBatchId",
        "baseName": "paymentBatchId",
        "type": "number"
    },
    {
        "name": "processorCode",
        "baseName": "processorCode",
        "type": "string"
    },
    {
        "name": "processorDescription",
        "baseName": "processorDescription",
        "type": "string"
    },
    {
        "name": "paymentMethodTypeCode",
        "baseName": "paymentMethodTypeCode",
        "type": "string"
    },
    {
        "name": "paymentMethodTypeDescription",
        "baseName": "paymentMethodTypeDescription",
        "type": "string"
    },
    {
        "name": "isBatchPayable",
        "baseName": "isBatchPayable",
        "type": "boolean"
    },
    {
        "name": "paymentBatchStatusCode",
        "baseName": "paymentBatchStatusCode",
        "type": "string"
    },
    {
        "name": "paymentBatchStatusDescription",
        "baseName": "paymentBatchStatusDescription",
        "type": "string"
    },
    {
        "name": "totalBatchAmount",
        "baseName": "totalBatchAmount",
        "type": "number"
    },
    {
        "name": "claimCount",
        "baseName": "claimCount",
        "type": "number"
    },
    {
        "name": "paymentBatchDetails",
        "baseName": "paymentBatchDetails",
        "type": ""
    },
    {
        "name": "parentPaymentBatchId",
        "baseName": "parentPaymentBatchId",
        "type": "number"
    },
    {
        "name": "processorId",
        "baseName": "processorId",
        "type": "number"
    },
    {
        "name": "promotionId",
        "baseName": "promotionId",
        "type": "number"
    },
    {
        "name": "paymentMethodTypeId",
        "baseName": "paymentMethodTypeId",
        "type": "number"
    },
    {
        "name": "paymentBatchStatusId",
        "baseName": "paymentBatchStatusId",
        "type": "number"
    },
    {
        "name": "paymentBatchStartDate",
        "baseName": "paymentBatchStartDate",
        "type": "Date"
    },
    {
        "name": "paymentBatchEndDate",
        "baseName": "paymentBatchEndDate",
        "type": "Date"
    },
    {
        "name": "invoiceNumber",
        "baseName": "invoiceNumber",
        "type": "number"
    },
    {
        "name": "externalReferences",
        "baseName": "externalReferences",
        "type": ""
    },
];
//# sourceMappingURL=claimPaymentBatchModel.js.map